<template>
    <section
        v-if="block?.items?.length"
        class="w-full bg-blue py-12 text-white lg:py-24"
    >
        <div class="mx-auto max-w-7xl">
            <div class="">
                <!-- COLUMN -->
                <div class="mx-auto max-w-5xl text-center">
                    <h2
                        class="font-aktivCondensed text-3xl font-extrabold uppercase sm:text-4xl xl:text-5xl"
                    >
                        {{ block.headline }}
                    </h2>
                </div>
            </div>

            <div
                class="mx-auto mt-6 grid max-w-xl grid-cols-1 gap-x-16 gap-y-10 md:grid-cols-2 lg:mt-8 lg:max-w-none lg:grid-cols-3 lg:gap-x-14"
            >
                <article
                    v-for="(item, i) in block.items"
                    :key="`${item.headline}-${i}`"
                    class="group relative flex flex-col items-center text-center"
                >
                    <img
                        :src="item.image.url"
                        :alt="item.image.alt"
                        loading="lazy"
                        decoding="async"
                        class="mx-auto w-full transition-opacity group-hover:opacity-95"
                    />

                    <h3
                        class="mt-2 font-aktivCondensed text-xl font-extrabold uppercase sm:text-2xl lg:mt-4"
                    >
                        <a
                            :href="item.ctaUrl"
                            :data-card-id="toSlug(item.headline)"
                            :data-card-label="item.headline"
                        >
                            <span class="absolute inset-0"></span>
                            {{ item.headline }}
                        </a>
                    </h3>

                    <p class="mt-1 flex-auto text-pretty lg:mt-2 lg:text-lg">
                        {{ item.copy }}
                    </p>
                    <div
                        class="mt-2 block rounded-full bg-white px-10 py-2.5 text-center font-semibold text-blue shadow-sm ring-2 ring-blue duration-150 hover:bg-transparent hover:text-blue hover:ring-blue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky group-hover:bg-transparent group-hover:text-white group-hover:ring-white lg:mt-4"
                    >
                        {{ item.ctaLabel }}
                    </div>
                </article>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { ResourcesBlock } from "../types";

defineProps<{
    block?: ResourcesBlock;
}>();

function toSlug(str: string) {
    return str
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/[^\w_]/g, "");
}
</script>

<style scoped></style>
